export default __webpack_public_path__ + "static/media/jeffery_felix.68975578.png";